module.exports = __webpack_public_path__ + "img/ShorterLogo.6b3e5c04.svg";